import React from 'react';
import classnames from 'classnames';

import SiteNavbarLink from 'components/SiteNavBar/SiteNavBarLink';
import loc from 'sources/locale/loc';
import { AppleIcon } from '../../icons';

import styles from './DownloadButton.scss';

export default function DownloadButton(props) {
  const { className } = props;

  return (
    <SiteNavbarLink
      httpLink
      Icon={AppleIcon}
      label={loc('download-on-ios-label')}
      path="https://apps.apple.com/us/app/potion-app/id1466218783?ls=1"
      variant="filled"
      className={classnames(className, styles.button)}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/controls/DownloadButton.jsx